/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const headerProvisionalDetailConfig = {
  headerLogo: 'https://s3.ap-south-1.amazonaws.com/io.irdai.demo/logo.png',
  headerLink: '#',
  headerTitle: 'Parametro',
  headerTitleStyle: {
    fontFamily: 'muli',
  },
  navItems: [
    {
      name: 'Products',
      link: '#products',
    },
  ],
  buttonItem: {
    name: 'Support',
    link: '#',
  },
  metaData: {
    title: 'Parametro',
    description: 'Parametro Insurance',
    favicon: 'https://i.ibb.co/C1SB8t7/favicon.png',
  },
};
